// Mock data for CapCut clone - Swedish & Arabic

export const translations = {
  sv: {
    dir: 'ltr',
    nav: {
      products: 'Produkter',
      create: 'Skapa',
      learn: 'Lär dig',
      pricing: 'Priser',
      business: 'För företag',
      login: 'Logga in',
      download: 'Ladda ner',
      free: 'Helt gratis'
    },
    hero: {
      badge: 'Helt gratis · Obegränsad tillgång',
      title: 'Allt-i-ett videoredigerare',
      titleAccent: 'gratis för alltid',
      subtitle: 'Skapa fantastiska videor med kraftfulla verktyg, AI-magi och tusentals mallar. Ingen betalning, ingen vattenstämpel, inga gränser.',
      ctaPrimary: 'Redigera i webbläsaren',
      ctaSecondary: 'Ladda ner appen',
      trust: 'Betrodd av 300M+ skapare världen över'
    },
    platforms: {
      title: 'Redigera var som helst, när som helst',
      subtitle: 'CapCut fungerar sömlöst på alla dina enheter',
      windows: 'Windows',
      mac: 'Mac',
      ios: 'iOS',
      android: 'Android',
      web: 'Webb'
    },
    features: {
      sectionLabel: 'Kraftfulla verktyg',
      title: 'Allt du behöver för att skapa magi',
      items: [
        { title: 'AI-videogenerator', desc: 'Förvandla text till professionella videor på sekunder med vår avancerade AI-motor.', tag: 'AI' },
        { title: 'Automatiska undertexter', desc: 'Generera exakta undertexter på 40+ språk med ett klick.', tag: 'Smart' },
        { title: 'Bakgrundsborttagning', desc: 'Ta bort bakgrunder från video och foto utan grön skärm.', tag: 'Ett klick' },
        { title: 'Röstförändrare', desc: 'Byt röst med hundratals AI-röster och effekter.', tag: 'Nyhet' },
        { title: 'Trendiga effekter', desc: 'Tusentals effekter, övergångar och filter uppdaterade dagligen.', tag: 'Populärt' },
        { title: 'Musikbibliotek', desc: 'Obegränsad tillgång till royaltyfri musik och ljudeffekter.', tag: 'Gratis' }
      ]
    },
    templates: {
      sectionLabel: 'Mallar',
      title: 'Skapa på sekunder med trendmallar',
      subtitle: 'Miljontals färdiga mallar för TikTok, Reels, YouTube Shorts och mer',
      useTemplate: 'Använd mall',
      viewAll: 'Se alla mallar'
    },
    showcase: {
      title: 'Från idé till viral video',
      desc: 'Kraftfull tidslinjeredigering, färgkorrigering i proffsklass, avancerad ljudmix och en enorm bank av mallar - allt i ett verktyg.',
      point1: 'Redigering i flera spår med obegränsade lager',
      point2: 'Realtidsförhandsvisning i 4K',
      point3: 'Nyckelbildruttor och rörelseövergångar',
      point4: 'Molnbaserad synk mellan enheter'
    },
    pricing: {
      badge: 'Vårt löfte',
      title: 'Helt gratis. Obegränsad tillgång.',
      subtitle: 'Vi tror att kreativitet inte ska ha ett prisstyrke. Alla proffsfunktioner - för alla.',
      features: [
        'Obegränsad videoexport i 4K',
        'Alla AI-verktyg utan gränser',
        'Ingen vattenstämpel någonsin',
        'Alla mallar och effekter',
        '100 GB molnlagring',
        'Kommersiell licens ingår',
        'Prioriterad support',
        'Framtida uppdateringar gratis'
      ],
      cta: 'Kom igång gratis',
      note: 'Inget kreditkort krävs · Ingen prövotid · Alltid gratis'
    },
    testimonials: {
      sectionLabel: 'Skapare älskar oss',
      title: 'Se vad världen skapar',
      items: [
        { name: 'Emma Lindberg', role: 'TikTok-skapare · 2.4M följare', text: 'CapCut har helt förändrat mitt sätt att skapa innehåll. AI-undertexterna är otroliga.' },
        { name: 'Ahmed Karim', role: 'YouTuber · 890K följare', text: 'Från gratis till proffs på minuter. Det bästa redigeringsverktyget jag någonsin har använt.' },
        { name: 'Sofia Bergström', role: 'Marknadsförare', text: 'Vi sparar tusentals kronor och skapar bättre videoinnehåll än någonsin tidigare.' },
        { name: 'Lucas Nilsson', role: 'Filmskapare', text: 'Proffsverktyg helt gratis? Det är för bra för att vara sant, men det är det.' }
      ]
    },
    footer: {
      product: 'Produkt',
      resources: 'Resurser',
      company: 'Företag',
      support: 'Support',
      language: 'Språk',
      rights: 'Alla rättigheter förbehållna.',
      tagline: 'Skapa. Redigera. Inspirera.'
    }
  },
  ar: {
    dir: 'rtl',
    nav: {
      products: 'المنتجات',
      create: 'إنشاء',
      learn: 'تعلم',
      pricing: 'الأسعار',
      business: 'للشركات',
      login: 'تسجيل الدخول',
      download: 'تنزيل',
      free: 'مجاني تماماً'
    },
    hero: {
      badge: 'مجاني تماماً · وصول غير محدود',
      title: 'محرر فيديو شامل',
      titleAccent: 'مجاني إلى الأبد',
      subtitle: 'أنشئ فيديوهات مذهلة بأدوات قوية وسحر الذكاء الاصطناعي وآلاف القوالب. بدون دفع، بدون علامة مائية، بدون حدود.',
      ctaPrimary: 'حرر في المتصفح',
      ctaSecondary: 'تنزيل التطبيق',
      trust: 'موثوق به من قبل أكثر من 300 مليون مبدع حول العالم'
    },
    platforms: {
      title: 'حرر في أي مكان وأي وقت',
      subtitle: 'يعمل كاب كت بسلاسة على جميع أجهزتك',
      windows: 'ويندوز',
      mac: 'ماك',
      ios: 'iOS',
      android: 'أندرويد',
      web: 'الويب'
    },
    features: {
      sectionLabel: 'أدوات قوية',
      title: 'كل ما تحتاجه لصنع السحر',
      items: [
        { title: 'مولد فيديو بالذكاء الاصطناعي', desc: 'حول النص إلى فيديو احترافي في ثوانٍ.', tag: 'ذكاء اصطناعي' },
        { title: 'الترجمة التلقائية', desc: 'أنشئ ترجمات دقيقة بأكثر من 40 لغة بنقرة واحدة.', tag: 'ذكي' },
        { title: 'إزالة الخلفية', desc: 'أزل الخلفيات من الفيديو والصور بدون شاشة خضراء.', tag: 'نقرة واحدة' },
        { title: 'مغير الصوت', desc: 'غير صوتك بمئات الأصوات والتأثيرات الذكية.', tag: 'جديد' },
        { title: 'تأثيرات رائجة', desc: 'آلاف التأثيرات والانتقالات والفلاتر يومياً.', tag: 'شائع' },
        { title: 'مكتبة موسيقى', desc: 'وصول غير محدود إلى موسيقى ومؤثرات صوتية مجانية.', tag: 'مجاني' }
      ]
    },
    templates: {
      sectionLabel: 'القوالب',
      title: 'أنشئ في ثوانٍ باستخدام القوالب الرائجة',
      subtitle: 'ملايين القوالب الجاهزة لتيك توك وريلز ويوتيوب شورتس',
      useTemplate: 'استخدم القالب',
      viewAll: 'عرض كل القوالب'
    },
    showcase: {
      title: 'من الفكرة إلى فيديو منتشر',
      desc: 'تحرير قوي متعدد المسارات، تصحيح ألوان احترافي، مزج صوتي متقدم، ومكتبة ضخمة من القوالب.',
      point1: 'تحرير متعدد المسارات بطبقات لا محدودة',
      point2: 'معاينة فورية بدقة 4K',
      point3: 'إطارات مفتاحية وانتقالات حركية',
      point4: 'مزامنة سحابية بين الأجهزة'
    },
    pricing: {
      badge: 'وعدنا',
      title: 'مجاني تماماً. وصول غير محدود.',
      subtitle: 'نؤمن بأن الإبداع لا يجب أن يكون له ثمن. جميع الميزات الاحترافية للجميع.',
      features: [
        'تصدير فيديو غير محدود بدقة 4K',
        'جميع أدوات الذكاء الاصطناعي بلا حدود',
        'بدون علامة مائية أبداً',
        'جميع القوالب والتأثيرات',
        '100 جيجابايت تخزين سحابي',
        'ترخيص تجاري مشمول',
        'دعم أولوية',
        'تحديثات مستقبلية مجانية'
      ],
      cta: 'ابدأ مجاناً',
      note: 'لا حاجة لبطاقة ائتمان · لا فترة تجريبية · مجاني دائماً'
    },
    testimonials: {
      sectionLabel: 'المبدعون يحبوننا',
      title: 'شاهد ما يبدعه العالم',
      items: [
        { name: 'إيما ليندبرغ', role: 'صانعة محتوى تيك توك · 2.4M متابع', text: 'كاب كت غيرت طريقتي في إنشاء المحتوى تماماً. ترجمات الذكاء الاصطناعي رائعة.' },
        { name: 'أحمد كريم', role: 'يوتيوبر · 890K متابع', text: 'من مجاني إلى احترافي في دقائق. أفضل أداة تحرير استخدمتها.' },
        { name: 'صوفيا برغستروم', role: 'مسوّقة رقمية', text: 'نوفر آلاف الكرونات وننتج محتوى فيديو أفضل من أي وقت.' },
        { name: 'لوكاس نيلسون', role: 'صانع أفلام', text: 'أدوات احترافية مجاناً؟ يبدو الأمر جيداً لدرجة لا تصدق، لكنه حقيقي.' }
      ]
    },
    footer: {
      product: 'المنتج',
      resources: 'الموارد',
      company: 'الشركة',
      support: 'الدعم',
      language: 'اللغة',
      rights: 'جميع الحقوق محفوظة.',
      tagline: 'أنشئ. حرر. ألهم.'
    }
  }
};

export const featureImages = [
  'https://images.unsplash.com/photo-1614963326505-843868e1d83a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1574717025058-2f8737d2e2b7?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1528109966604-5a6a4a964e8d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1485846234645-a62644f84728?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1611162616475-46b635cb6868?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85'
];

export const creatorImages = [
  'https://images.unsplash.com/photo-1759393852314-59dc00faeed3?crop=entropy&cs=srgb&fm=jpg&w=800&q=85',
  'https://images.unsplash.com/photo-1609177336889-4e69aa3b1ff6?crop=entropy&cs=srgb&fm=jpg&w=800&q=85',
  'https://images.unsplash.com/photo-1719937051157-d3d81cc28e86?crop=entropy&cs=srgb&fm=jpg&w=800&q=85',
  'https://images.unsplash.com/photo-1726066012749-f81bf4422d4e?crop=entropy&cs=srgb&fm=jpg&w=800&q=85'
];

const V = 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4';
const V2 = 'https://test-videos.co.uk/vids/jellyfish/mp4/h264/360/Jellyfish_360_10s_1MB.mp4';
const V3 = 'https://download.blender.org/durian/trailer/sintel_trailer-480p.mp4';
export const templates = [
  { id: 1, title: 'Sommarvibbar', category: 'Reels', duration: '0:15', uses: '1.2M', img: 'https://images.unsplash.com/photo-1759393852314-59dc00faeed3?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['sommar', 'strand', 'sol'] },
  { id: 2, title: 'Tech Reveal', category: 'YouTube', duration: '0:30', uses: '890K', img: 'https://images.unsplash.com/photo-1614963326505-843868e1d83a?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['tech', 'unboxing', 'produkt'] },
  { id: 3, title: 'Foodie POV', category: 'TikTok', duration: '0:22', uses: '2.1M', img: 'https://images.unsplash.com/photo-1609177336889-4e69aa3b1ff6?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['mat', 'recept', 'kök'] },
  { id: 4, title: 'Fitness Motion', category: 'Reels', duration: '0:18', uses: '540K', img: 'https://images.unsplash.com/photo-1719937051157-d3d81cc28e86?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['träning', 'gym', 'hälsa'] },
  { id: 5, title: 'Travel Diary', category: 'YouTube', duration: '0:45', uses: '1.7M', img: 'https://images.unsplash.com/photo-1726066012749-f81bf4422d4e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['resa', 'äventyr', 'natur'] },
  { id: 6, title: 'Beat Drop', category: 'TikTok', duration: '0:12', uses: '3.4M', img: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['musik', 'dance', 'trend'] },
  { id: 7, title: 'Product Launch', category: 'Reels', duration: '0:25', uses: '420K', img: 'https://images.unsplash.com/photo-1611162616475-46b635cb6868?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['produkt', 'reveal', 'brand'] },
  { id: 8, title: 'Aesthetic Vlog', category: 'YouTube', duration: '0:35', uses: '980K', img: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['vlog', 'lifestyle', 'aesthetic'] },
  { id: 9, title: 'Bröllop Drömmar', category: 'YouTube', duration: '1:00', uses: '2.4M', img: 'https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['bröllop', 'kärlek', 'romantik'] },
  { id: 10, title: 'Skönhet & Makeup', category: 'TikTok', duration: '0:20', uses: '1.8M', img: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['skönhet', 'makeup', 'sminkning'] },
  { id: 11, title: 'Gaming Highlights', category: 'YouTube', duration: '0:40', uses: '3.1M', img: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['gaming', 'esport', 'streamer'] },
  { id: 12, title: 'Cinematic Sunset', category: 'Reels', duration: '0:20', uses: '760K', img: 'https://images.unsplash.com/photo-1470813740244-df37b8c1edcb?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['cinematic', 'solnedgång', 'himmel'] },
  { id: 13, title: 'Dans Utmaning', category: 'TikTok', duration: '0:15', uses: '4.2M', img: 'https://images.unsplash.com/photo-1547153760-18fc86324498?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['dans', 'utmaning', 'viral'] },
  { id: 14, title: 'Barndagbok', category: 'Reels', duration: '0:30', uses: '1.5M', img: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['familj', 'barn', 'minnen'] },
  { id: 15, title: 'Bilkultur', category: 'YouTube', duration: '0:50', uses: '890K', img: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['bil', 'motor', 'auto'] },
  { id: 16, title: 'Kaffemorgon', category: 'Reels', duration: '0:12', uses: '680K', img: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['kaffe', 'morgon', 'mysig'] },
  { id: 17, title: 'Skateboard', category: 'TikTok', duration: '0:18', uses: '1.3M', img: 'https://images.unsplash.com/photo-1520045892732-304bc3ac5d8e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['skateboard', 'street', 'trick'] },
  { id: 18, title: 'Husdjur Roligt', category: 'Reels', duration: '0:15', uses: '5.6M', img: 'https://images.unsplash.com/photo-1543852786-1cf6624b9987?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['katt', 'hund', 'husdjur'] },
  { id: 19, title: 'Mode Runway', category: 'YouTube', duration: '0:45', uses: '720K', img: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['mode', 'runway', 'stil'] },
  { id: 20, title: 'Natur Timelapse', category: 'YouTube', duration: '1:00', uses: '2.0M', img: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['natur', 'timelapse', 'landskap'] },
  { id: 21, title: 'Bakning', category: 'TikTok', duration: '0:25', uses: '1.1M', img: 'https://images.unsplash.com/photo-1495147466023-ac5c588e2e94?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['bakning', 'kaka', 'recept'] },
  { id: 22, title: 'Stadsliv', category: 'Reels', duration: '0:22', uses: '830K', img: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V, tags: ['stad', 'urban', 'liv'] },
  { id: 23, title: 'Konstverkstad', category: 'YouTube', duration: '0:35', uses: '450K', img: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V2, tags: ['konst', 'måleri', 'kreativ'] },
  { id: 24, title: 'Musik Studio', category: 'TikTok', duration: '0:20', uses: '960K', img: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', video: V3, tags: ['musik', 'studio', 'inspelning'] }
];

const S = 'https://www.soundhelix.com/examples/mp3/';
export const musicTracks = [
  { id: 't1', title: 'Neon Dreams', artist: 'Aurora Beats', genre: 'Electronic', mood: 'Energisk', duration: '2:45', bpm: 128, url: S + 'SoundHelix-Song-1.mp3', color: 'from-cyan-500 to-blue-600' },
  { id: 't2', title: 'Golden Hour', artist: 'Lo-Fi Lounge', genre: 'Lo-Fi', mood: 'Chill', duration: '3:12', bpm: 90, url: S + 'SoundHelix-Song-2.mp3', color: 'from-amber-400 to-orange-500' },
  { id: 't3', title: 'Skyline Rush', artist: 'Pulse Wave', genre: 'Synthwave', mood: 'Episk', duration: '2:58', bpm: 140, url: S + 'SoundHelix-Song-3.mp3', color: 'from-fuchsia-500 to-pink-600' },
  { id: 't4', title: 'Forest Whispers', artist: 'Nordic Sound', genre: 'Ambient', mood: 'Lugn', duration: '4:02', bpm: 70, url: S + 'SoundHelix-Song-4.mp3', color: 'from-emerald-400 to-teal-600' },
  { id: 't5', title: 'City Beats', artist: 'Metro Groove', genre: 'Hip-Hop', mood: 'Trendig', duration: '2:22', bpm: 95, url: S + 'SoundHelix-Song-5.mp3', color: 'from-violet-500 to-indigo-600' },
  { id: 't6', title: 'Summer Wave', artist: 'Coastal', genre: 'Pop', mood: 'Glad', duration: '3:34', bpm: 118, url: S + 'SoundHelix-Song-6.mp3', color: 'from-rose-400 to-red-500' },
  { id: 't7', title: 'Midnight Coffee', artist: 'Jazz Room', genre: 'Jazz', mood: 'Mysig', duration: '3:48', bpm: 82, url: S + 'SoundHelix-Song-7.mp3', color: 'from-yellow-500 to-amber-600' },
  { id: 't8', title: 'Rocket Launch', artist: 'Cinema FX', genre: 'Cinematic', mood: 'Dramatisk', duration: '2:12', bpm: 145, url: S + 'SoundHelix-Song-8.mp3', color: 'from-slate-600 to-neutral-800' }
];

export const musicI18n = {
  sv: {
    sectionLabel: 'Musikbibliotek',
    title: 'Trendig musik. Alltid gratis.',
    subtitle: 'Tusentals royaltyfria spår för dina videor - förhandslyssna och lägg till med ett klick',
    search: 'Sök spår, artist eller genre...',
    genres: ['Alla', 'Electronic', 'Lo-Fi', 'Pop', 'Hip-Hop', 'Jazz', 'Ambient', 'Cinematic', 'Synthwave'],
    moods: ['Alla stämningar', 'Energisk', 'Chill', 'Episk', 'Lugn', 'Trendig', 'Glad', 'Mysig', 'Dramatisk'],
    add: 'Lägg till i projekt',
    added: 'Tillagd!',
    bpm: 'BPM',
    noResults: 'Inga spår hittades. Prova en annan sökning.',
    projectCount: 'i ditt projekt'
  },
  ar: {
    sectionLabel: 'مكتبة الموسيقى',
    title: 'موسيقى رائجة. مجانية دائماً.',
    subtitle: 'آلاف المقاطع الخالية من حقوق الملكية لفيديوهاتك - استمع وأضف بنقرة واحدة',
    search: 'ابحث عن مقطع أو فنان أو نوع...',
    genres: ['الكل', 'إلكترونية', 'لو-فاي', 'بوب', 'هيب-هوب', 'جاز', 'محيطية', 'سينمائية', 'سينثويف'],
    moods: ['جميع الأجواء', 'حماسية', 'هادئة', 'ملحمية', 'سكينة', 'رائجة', 'مبهجة', 'دافئة', 'درامية'],
    add: 'أضف إلى المشروع',
    added: 'تمت الإضافة!',
    bpm: 'BPM',
    noResults: 'لا توجد نتائج. جرّب بحثاً آخر.',
    projectCount: 'في مشروعك'
  }
};

export const modalI18n = {
  sv: { useNow: 'Använd mall nu', save: 'Spara', remix: 'Remixa', share: 'Dela', clips: 'Klipp', duration: 'Längd', likes: 'Gilla', uses: 'Användningar', description: 'Snygg trendmall med färdiga övergångar, ljudsync och textanimationer. Byt bara ut klippen mot dina egna och exportera i 4K.' },
  ar: { useNow: 'استخدم القالب الآن', save: 'حفظ', remix: 'إعادة مزج', share: 'مشاركة', clips: 'مقاطع', duration: 'المدة', likes: 'إعجابات', uses: 'استخدامات', description: 'قالب رائج بانتقالات جاهزة ومزامنة صوتية وتحريكات نصية. فقط استبدل المقاطع بمقاطعك وصدّر بدقة 4K.' }
};

export const stats = [
  { value: '300M+', labelSv: 'Aktiva skapare', labelAr: 'مبدع نشط' },
  { value: '10B+', labelSv: 'Videor skapade', labelAr: 'فيديو تم إنشاؤه' },
  { value: '500K+', labelSv: 'Mallar', labelAr: 'قالب' },
  { value: '190+', labelSv: 'Länder', labelAr: 'دولة' }
];
